import { z } from 'zod';

export const ACCESS_POLICY_CONSOLE_TABS = [
  'functional_groups',
  'data_groups',
  'grants',
  'sod_conflicts',
  'restricted_lists',
  'recertification',
] as const;
export type AccessPolicyConsoleTab = (typeof ACCESS_POLICY_CONSOLE_TABS)[number];

export const AccessPolicyConsolePayloadSchema = z.object({
  /** Tab to activate on open. Defaults to 'functional_groups'. */
  tab: z.enum(ACCESS_POLICY_CONSOLE_TABS).optional(),
});

export type AccessPolicyConsolePayload = z.infer<typeof AccessPolicyConsolePayloadSchema>;
